const ta = typeof document !== "undefined" ? document.createElement("textarea") : null;

const LABELS = { qualification: "Qualification", cut_off: "Minimum marks", other_eligibility: "Other" };
const unserialize = (s) => {
  const parts = [...s.matchAll(/s:\d+:"([^"]*)"/g)].map((m) => m[1]);
  const out = [];
  let cur = null;
  parts.forEach((p) => { if (LABELS[p]) { cur = { k: LABELS[p], v: [] }; out.push(cur); } else if (cur && p) cur.v.push(p); });
  return out.filter((x) => x.v.length).map((x) => `${x.k}: ${x.v.join(", ")}`).join(" · ");
};

export const strip = (h) => {
  if (/^a:\d+:\{/.test(h || "")) return unserialize(h);
  const s = (h || "").replace(/<[^>]+>/g, " ");
  if (!ta) return s.replace(/\s+/g, " ").trim();
  ta.innerHTML = s;
  return ta.value.replace(/\s+/g, " ").trim();
};
